import { Paper, type PaperProps, Skeleton, Stack } from "@mui/material";
import { HeadingM } from "@repo/ui";
import { type FC, isValidElement, type ReactElement, type ReactNode } from "react";
import HeaderWithDescription, {
	type HeaderWithDescriptionProps,
} from "../HeaderWithDescription";

type InformationsListProps = PaperProps & {
	title: string | ReactNode;
	information: (HeaderWithDescriptionProps | ReactElement)[];
	isLoading: boolean;
	icon?: ReactElement | ReactNode;
}

const InformationsList: FC<InformationsListProps> = ({
	title,
	information,
	sx,
	isLoading,
	icon,
}) => {
	return (
		<Paper
			sx={{
				height: "100%",
				p: 4,
				...sx,
			}}
		>
			{icon}
			<HeadingM sx={{ pl: 5, py: 4, backgroundColor: "#F1EDEB" }}>
				{isLoading ? <Skeleton width={200} /> : title}
			</HeadingM>
			<Stack spacing={4}>
				{information.map((singleInformation) => {
					if (isValidElement(singleInformation)) {
						return singleInformation;
					} 
					const params = isLoading
						? {
							title: singleInformation.title || <Skeleton width={200} />,
							description: <Skeleton width={200} />,
							additionalElements: singleInformation.additionalElements && (
								<Skeleton width={50} />
							),
						}
						: singleInformation;
					return (
						<HeaderWithDescription
							key={singleInformation.title}
							{...params}
							swipeable={true}
						/>
					);
				})}
			</Stack>
		</Paper>
	);
}

export default InformationsList;
